export const signUpLink = '/sign-up';

export const signInLink = '/sign-in';

export const myBusinessLink = '/my-business';

export const welcomeUserLink = '/welcome-business';

export const oneProductPageLink = '/business/?shop_id=1/?product_id=1';